export const PLAYBACK_DECISIONS = [
    'directplay',
    'copy',
    'audio_transcode',
    'transcode',
];
/** Keys in the `common` translation namespace, without the namespace prefix. */
export const PLAYBACK_DECISION_LABEL_KEYS = {
    directplay: 'playback.directPlay',
    copy: 'playback.directStream',
    audio_transcode: 'playback.audioTranscode',
    transcode: 'playback.transcode',
};
/**
 * Tiered by the costliest stream: any video transcode is a Transcode, an audio
 * transcode over untouched video is an Audio Transcode, and any copied stream
 * makes the session a Direct Stream.
 */
export function playbackDecision(session) {
    if (session.isTranscode) {
        return session.audioDecision === 'transcode' && session.videoDecision !== 'transcode'
            ? 'audio_transcode'
            : 'transcode';
    }
    return session.videoDecision === 'copy' || session.audioDecision === 'copy'
        ? 'copy'
        : 'directplay';
}
/**
 * Plex marks the subtitle stream `burn`; Jellyfin and Emby only list a subtitle
 * transcode reason, and only when the server decides to burn in, not when the
 * user forces it.
 */
export function isSubtitleBurnIn(session) {
    return (session.subtitleInfo?.decision === 'burn' ||
        (session.transcodeInfo?.reasons?.includes('SubtitleCodecNotSupported') ?? false));
}
//# sourceMappingURL=playbackDecision.js.map